export default __webpack_public_path__ + "static/media/app_waffle.3d675da1.png";